import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ReactiveFormsModule } from '@angular/forms';

import { BankComponent } from './bank.component';
import { BankRoutingModule } from './bank-routing.module';
import { BankingInfoModule } from 'src/app/components/controls/banking-info/banking-info.module';
import { SecureInfoModule } from 'src/app/components/controls/secure-info/secure-info.module';
import { ElectronicSignatureInfoModule } from 'src/app/components/controls/electronic-signature-info/electronic-signature-info.module';
import { ValidationTextModule } from 'src/app/components/validation-text/validation-text.module';

@NgModule({
  declarations: [BankComponent],
  imports: [
    CommonModule,
    ReactiveFormsModule,
    BankRoutingModule,
    BankingInfoModule,
    SecureInfoModule,
    ElectronicSignatureInfoModule,
    ValidationTextModule,
  ],
})
export class BankModule {}
